import {
    CheckCircle2,
    HelpCircle,
    Undo2,
    XCircle,
    RotateCcw,
    SlidersHorizontal,
    GalleryHorizontalEnd,
    Delete
} from "lucide-react";
import { onReadyClick, TrainingOptions } from './.utils/operatorUtils';
import { useEffect, useState } from "react";
import { AnimatePresence } from "motion/react";
import { HopAnimation } from "../../animations/Hop";
import { useNavigate } from "react-router-dom";
import { PulseGlow } from "../../animations/PulseGlow";
import MathSettingsDialog from "../../dialog/math/Settings";
import Dialog from "../../dialog/Dialog";
import * as motion from "motion/react-client";

const AdditionPage = () => {
    const navigate = useNavigate();

    const [settingsDialogOpen, setSettingsDialogOpen] = useState<boolean | undefined>(undefined)
    const [questionIndex, setQuestionIndex] = useState<number>(0)
    const [addend, setAddend] = useState<number>(0)
    const [addend2, setAddend2] = useState<number>(0)
    const [questionSet, setQuestionSet] = useState<number[][]>([[addend2, addend]])
    const [userInputIndex, setUserInputIndex] = useState<number[]>([]);
    const [userInputBtnNums, _] = useState((Array.from({ length: 10 }, (_, i) => 9 - i)))
    const [submitted, setSubmitted] = useState(false)
    const [showHelperAnswer, setShowHelperAnswer] = useState(false)
    const [showHelperBtn, setShowHelperBtn] = useState(false)
    const [WHAT_IS_THE_SUM, _3] = useState("What is the sum?")
    const [CORRECT, _4] = useState("Correct")
    const [INCORRECT, _5] = useState("Try Again")
    const [SELECT_SETTINGS, _6] = useState("Select Settings")
    const [COMPLETE, _7] = useState("All questions complete!")
    const [trainingOptions, setTrainingOptions] = useState<TrainingOptions>();
    const [savedTrainingOptions, setSavedTrainingOptions] = useState<TrainingOptions>();
    const [filterChips, setFilterChips] = useState<string[]>([]);
    const [subtitle, setSubtitle] = useState(WHAT_IS_THE_SUM)
    // const [helperAnimationTimer, startHelperAnimationTimer] = useState<boolean>(false);

    const { getAnimation } = new HopAnimation()
    const { animate: hopAnimate, transition: hopTransition } = getAnimation()
    const { getAnimation: getPulseGlow } = new PulseGlow()
    const { animate: pulseAnimate, transition: pulseTransition} = getPulseGlow()

    useEffect(() => {
        // Opens the dialog after 3 sec... For initializing settings; this will not repeat
        if (questionSet.length <= 1 || !questionSet) {
            setSubtitle(SELECT_SETTINGS)
        }
    }, [questionSet]);

    useEffect(() => {
        console.log("dialog open", settingsDialogOpen)
        if (settingsDialogOpen && trainingOptions?.ready) {
            const questions = onReadyClick(trainingOptions, "+");
            if (questions) {
                setQuestionSet(questions)
                setQuestionIndex(0)
                setUserInputIndex([])
                setSubtitle(WHAT_IS_THE_SUM)
            }
            setShowHelperBtn(trainingOptions?.Helper ?? false)
            setSavedTrainingOptions(trainingOptions)
            setTrainingOptions(undefined)
            setSettingsDialogOpen(false)
            if (submitted) {
                setSubmitted(false)
            }
            // if (trainingOptions?.Helper) {
            //     setInterval(() => {
            //         startHelperAnimationTimer(true)
            //     }, 4_000)
            // }
        }
    }, [trainingOptions, settingsDialogOpen]);

    useEffect(() => {
        if (questionSet && questionSet.length > 0) {
            const question = questionSet[1]
            setAddend(questionSet[questionIndex][0])
            setAddend2(questionSet[questionIndex][1])
        } else {
            console.log("No questions to display! or maybe set questionSet to [[]]?")
        }
    }, [questionSet]);

    useEffect(() => {
        if (trainingOptions) {
            const result: string[] = [];
            if (trainingOptions.Helper) {
                result.push("Helper")
            }
            if (trainingOptions.Shuffle) {
                result.push("Shuffled")
            }
            if (trainingOptions.Tables.length === 0) return;

            const sorted = [...trainingOptions.Tables].sort((a, b) => a - b);


            let start = sorted[0];
            let prev = sorted[0];

            for (let i = 1; i < sorted.length; i++) {
                const n = sorted[i];

                if (n === prev + 1) {
                    prev = n;
                    continue;
                }

                result.push(start === prev ? `${start}'s` : `${start}-${prev}'s`);

                start = n;
                prev = n;
            }
            result.push(start === prev ? `${start}'s` : `${start}-${prev}'s`);

            setFilterChips(result);
        }
    }, [trainingOptions]);

    const handleReset = () => {
        if (questionSet) {
            setQuestionIndex(0)
            setUserInputIndex([])
            setSubtitle(WHAT_IS_THE_SUM)
            setAddend(questionSet[0][0])
            setAddend2(questionSet[0][1])
            setSubmitted(false)
        }
    }

    const handleHelpClick = () => {
        setShowHelperAnswer(true)
        setTimeout(() => {
            setShowHelperAnswer(false)
        }, 2_000)
    }
    const handleUserInputClick = (num: number) => {
        if (showHelperAnswer) {
            setShowHelperAnswer(false)
        }
        if (subtitle === WHAT_IS_THE_SUM) {
            const answers = userInputIndex ?? []
            if (answers.length < 4) {
                setUserInputIndex(prev => [...prev, num]);
            } else {
                const foo: number[] = [...answers.filter((_, i) => i > 0), num];
                setUserInputIndex(foo)
            }
        }
    };
    const handleClear = () => {
        const userInputIndexEnd = userInputIndex.length - 1 ?? -1;
        const userInput = userInputIndex.filter((_, i) => i < userInputIndexEnd) ?? []
        setUserInputIndex(userInput)
    }
    const checkAnswer = () => {
        const input = Number.parseInt(userInputIndex.join(''))
        console.log("input",input)
        if (!isNaN(input)) {
            setSubmitted(true)
            updateUI(addend + addend2 === input ? CORRECT : INCORRECT)
        }
    }
    const updateUI = (correct: string) => {
        setSubtitle(correct);

        if (correct === CORRECT) {
            setQuestionIndex(prev => {
                console.log("prev", prev)
                return prev + 1
            })
            console.log("questionIndex:", questionIndex, " | questionSet.length:", questionSet.length)
            if (questionIndex === questionSet.length - 1) {
                console.log(COMPLETE)
                setSubtitle(COMPLETE)
                console.log("Here's your score:")
            } else {
                console.log("questionIndex", questionIndex)
                console.log("questionSet", questionSet, ' len -1', questionSet.length - 1)
                setTimeout(() => {
                    if (questionIndex < questionSet.length - 1) {
                        setAddend(questionSet[questionIndex + 1][0])
                        setAddend2(questionSet[questionIndex + 1][1])
                    }
                    setSubtitle(WHAT_IS_THE_SUM)
                    setSubmitted(false)
                    setUserInputIndex([])
                }, 1_500)
            }
        }

        if (correct === INCORRECT) {
            setTimeout(() => {
                setSubtitle(WHAT_IS_THE_SUM)
                setSubmitted(false)
                setUserInputIndex([])
            }, 700)
        }

    }
    const active = true
    return (
        <div className="w-4/5 md:w-80 flex flex-col items-center justify-center gap-4">
            {/* page title */}
            <motion.div className="flex flex-row justify-center items-center gap-2 mb-4">

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="m-auto"
                >
                    <GalleryHorizontalEnd size={50} />
                </motion.div>
                <motion.div
                    className="text-4xl font-bold text-white text-center"
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    Addition
                </motion.div>
            </motion.div>
            {/* button bar */}
            <motion.div className="grid grid-cols-3 items-center justify-center gap-3 w-5/6 mx-auto">
                {/* back button */}
                <motion.button className="flex justify-center text-xl p-2 border-2 border-white bg-transparent hover:bg-slate-500 rounded-xl"
                               onClick={() => navigate("/math")}>
                    <Undo2 size={"1.7em"}/>
                </motion.button>
                {/* restart button */}
                <motion.button className="flex justify-center text-lg p-2 bg-pink-500 hover:bg-pink-400 rounded-xl"
                               disabled={subtitle === SELECT_SETTINGS}
                               onClick={() => handleReset()}>
                    <RotateCcw size={"2em"}/>
                </motion.button>
                {/* settings button */}
                <motion.button className="flex justify-center text-lg p-2 bg-violet-600 hover:bg-violet-500 rounded-xl"
                               initial={{ y: 0 }}
                               animate={settingsDialogOpen === undefined ? hopAnimate : undefined}
                               transition={settingsDialogOpen === undefined ? hopTransition : undefined}
                               onClick={() => setSettingsDialogOpen(true)}>
                    <SlidersHorizontal size={"2em"}/>
                </motion.button>
            </motion.div>
            {/* filters - selected filter area */}
            <motion.div className="flex flex-row flex-wrap gap-2 w-full justify-center items-center ">
                {filterChips && filterChips.map((filter, i) => (
                    <motion.div
                        key={`chip-${filter.split(" ").join("")}`}
                        initial={{ opacity: 0, scale: 0.8, y: -6 }}
                        animate={{ opacity: 1, scale: active ? 1.05 : 1, y: 0 }}
                        transition={{ duration: 0.25, delay: 1.5 + i/6 }}
                        className={`px-2 py-0 w-fit rounded-full text-sm font-semibold select-none border
                        ${active
                            ? "bg-blue-600 text-white border-blue-700 shadow-md"
                            : "bg-gray-100 text-gray-700 border-gray-300"
                        }` }>
                        {filter}
                    </motion.div>
                ))}

            </motion.div>
            {/* calculator container */}
            <motion.div
                key={submitted ? "pulseAnimate-on" : "pulseAnimate-off"}
                initial={{ opacity: 1, scale: 1 }}
                animate={submitted && subtitle === COMPLETE ? pulseAnimate : undefined}
                transition={submitted && subtitle === COMPLETE ? pulseTransition : undefined}
                className={`relative flex flex-col items-center gap-6 p-6 rounded-3xl shadow-lg mx-auto border-2
                            ${subtitle === WHAT_IS_THE_SUM ? "border-gray-200" : ""}
                            ${subtitle === CORRECT ? "border-green-600" : ""}
                            ${subtitle === INCORRECT ? "border-red-500" : ""}`}
            >
                {/* subtitle / status */}
                <motion.p
                    key={subtitle}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-xl font-bold w-full flex justify-center">
                    {subtitle === SELECT_SETTINGS && (
                        <span className="flex items-center gap-2 bg-gradient-to-r bg-gradient-to-r bg-gradient-to-r from-blue-400 via-teal-400 to-purple-400 bg-clip-text text-transparent">
                            <SlidersHorizontal className="w-6 h-6" color="#60a5fa" /> {SELECT_SETTINGS}
                        </span>
                    )}
                    {subtitle === CORRECT && (
                        <span className="flex items-center gap-2 text-green-600">
                            <CheckCircle2 className="w-6 h-6" /> {CORRECT}
                        </span>
                    )}
                    {subtitle === INCORRECT && (
                        <span className="flex items-center gap-2 text-red-500">
                            <XCircle className="w-6 h-6" /> {INCORRECT}
                        </span>
                    )}
                    {subtitle !== CORRECT && subtitle !== INCORRECT && subtitle !== SELECT_SETTINGS &&
                        <span className="bg-gradient-to-r from-emerald-200 via-green-200 to-teal-200 bg-clip-text text-transparent">
                            {subtitle}
                        </span>
                    }
                </motion.p>

                {/* Problem Display */}
                <motion.div
                    className="flex justify-between gap-2 w-full"
                    animate={{
                        opacity: 1,
                        y: 0,
                        color: subtitle === SELECT_SETTINGS ? "transparent" : "#000",
                    }}
                    transition={{ duration: 0.4 }}>
                    <motion.div
                        layout
                        className="align-baseline w-full text-4xl font-extrabold"
                    >
                        <motion.div
                            key={`${addend}-${addend2}`}
                            initial={{ scale: 0.85, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.4 }}
                            className="flex justify-center gap-3 w-fit m-auto gap-4 transition-transform duration-300 bg-gradient-to-r from-blue-400 via-teal-300 to-cyan-400 bg-clip-text text-transparent"
                        >
                            <motion.div initial={{ opacity: 1 }}
                                        animate={{ opacity: subtitle === SELECT_SETTINGS ? 0 : 1 }}
                                        className={`${subtitle === CORRECT ? "text-green-700" : ""} w-fit flex justify-center`}>
                                {addend}
                            </motion.div>
                            <motion.div initial={{ opacity: 1 }}
                                        animate={{ opacity: subtitle === SELECT_SETTINGS ? 0 : 1 }}
                                        className={`${subtitle === CORRECT ? "text-green-700" : ""} w-fit flex justify-center`}>
                                +
                            </motion.div>
                            <motion.div initial={{ opacity: 1 }}
                                        animate={{ opacity: subtitle === SELECT_SETTINGS ? 0 : 1 }}
                                        className={`${subtitle === CORRECT ? "text-green-700" : ""} w-fit flex justify-center`}>
                                {addend2}
                            </motion.div>
                            <motion.div initial={{ opacity: 1 }}
                                        animate={{ opacity: subtitle === SELECT_SETTINGS ? 0 : 1 }}
                                        className={`${subtitle === CORRECT ? "text-green-700" : ""} w-fit flex justify-center`}>
                                =
                            </motion.div>
                            <AnimatePresence mode="wait">
                                {!showHelperAnswer ? (
                                    <motion.div
                                        key="user-answer"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        className="text-green-700"
                                    >
                                        {userInputIndex.join("")}
                                    </motion.div>
                                ) : (
                                    <motion.div
                                        key="helper-answer"
                                        initial={{ scale: 0.8, opacity: 0 }}
                                        animate={{ scale: 1, opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        className="text-gray-400"
                                    >
                                        {addend + addend2}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    </motion.div>
                </motion.div>
                {/* Number Buttons */}
                <div className="grid grid-cols-3 gap-2 w-full">
                    {userInputBtnNums.map((num) => (
                        <motion.button
                            whileTap={{ scale: 0.9 }}
                            key={num}
                            onClick={() => handleUserInputClick(num)}
                            className="bg-green-500 hover:bg-green-700 transition-colors text-2xl font-semibold rounded-xl py-2 shadow-sm"
                        >
                            {num}
                        </motion.button>
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="grid grid-cols-3  w-full">
                    <motion.button
                        whileTap={{ scale: 0.95 }}
                        onClick={handleClear}
                        className="bg-red-400 hover:bg-red-600 transition-colors rounded-xl px-4 py-2 text-lg font-medium"
                    >
                        <Delete size={"2em"} />
                    </motion.button>
                    <motion.div className="flex justify-center items-center">
                        {showHelperBtn && (
                            <motion.div
                                initial={{ y: 0 }}
                                animate={{ y: [0, -9, 0, -3, 0] }}
                                transition={{ duration: 0.8, delay: 2 }}
                            >
                                <motion.button
                                    initial={{ scale: 1 }}
                                    animate={{ scale: [1.5, 1, 1.5] }}
                                    transition={{ duration: 0.8, delay: 8, repeat: Infinity }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={handleHelpClick}
                                    className="w-fit bg-gradient-to-tr hover:bg-gradient-to-tr transition-colors p-2 rounded-full shadow-md"
                                >
                                    <HelpCircle className="w-6 h-6 text-gray-300" />
                                </motion.button>
                            </motion.div>
                        )}
                    </motion.div>
                    <motion.button
                        whileTap={{ scale: submitted ? 1 : 0.95 }}
                        onClick={checkAnswer}
                        disabled={submitted}
                        className={`${
                            submitted ? "bg-blue-200 hover:bg-blue-300" : "bg-blue-500 hover:bg-blue-600"
                        } transition-colors rounded-xl px-4 py-2 text-xl font-medium`}
                    >
                        Enter
                    </motion.button>
                </div>
            </motion.div>
            {settingsDialogOpen &&
                <Dialog open={settingsDialogOpen}
                        onClose={setSettingsDialogOpen}
                        childRef={
                            <MathSettingsDialog currentSettings={savedTrainingOptions} updateSettingsFn={setTrainingOptions} />
                        }
                />
            }
        </div>
    );
}

export default AdditionPage;